<template>
  <div>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom border-light">
            <h5>ダッシュボード</h5>
            <div class="d-flex float-right">
              <h5 class="text-secondary"><b-badge variant="light">最終更新 : {{l_lastdataupdate}}</b-badge></h5>
              <!-- <b-button size="sm" class="mb-2" variant="outline-secondary">
                データを更新する<b-icon icon="arrow-clockwise" aria-label="Help" class="ml-1"></b-icon>
              </b-button> -->
            </div>
          </div>

        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card no-body class="shadow-sm">
            <StationMapModule ref="stationMapModule" ></StationMapModule>
          </b-card>
        </b-col>
      </b-row>

    </b-container>

  </div>
</template>

<script>
import StationMapModule from './../modules/StationMapModule.vue'
export default {
  components: {
      StationMapModule
  },
  data() {
    return {
      // View Condition Parameters
      l_vehicle_selected: 'All',
      l_vehicle_options: [
        { value: 'All', text: 'すべて', buttonVariant: 'outline-dark'},
        { value: 'Active', text: '稼働中', buttonVariant: 'outline-info' },
        { value: 'InActive', text: '停止中', buttonVariant: 'outline-primary' },
      ],
      l_household_selected: 'All',
      l_household_options: [
        { value: 'All', text: 'すべて', buttonVariant: 'outline-dark' },
        { value: 'Empty', text: '回収済', buttonVariant: 'outline-info' },
        { value: 'Full', text: '未回収', buttonVariant: 'outline-danger' },
      ],
      l_recycle_selected: 'All',
      l_recycle_options: [
        { value: 'All', text: 'すべて', buttonVariant: 'outline-dark' },
        { value: 'Empty', text: '回収/設置済', buttonVariant: 'outline-secondary' },
        { value: 'Full', text: '未回収', buttonVariant: 'outline-primary' },
        { value: 'NoReady', text: '未設置', buttonVariant: 'outline-warning' },
      ],
      l_duration_selected: 'All',
      l_duration_options: [
        { value: 'All', text: 'すべて', buttonVariant: 'outline-dark' },
        { value: 'Today', text: '本日分' },
      ],
      l_lastdataupdate: null

    }
  },
  // Initialized Event & Lifecycle
  beforeCreate() {
  },
  // Initialized Injection & Reactivity
  created() {
  },
  // Processed the following
  beforeMount() {
    // 1.Has "el" option?
    //   Yes  -> No action
    //   No   -> vm.&mount(el) is called.
    // 2.Has "template" option?
    //   Yes  -> Compile template into render function.
    //   No   -> Compile el's outerHTML as template
  },
  // Created vm.$el and replaced "el" with it.
  mounted() {
    // 初期値をストアから取得
    this.l_lastdataupdate = this.$store.getters.todayStationDataRefreshTime;
		this.$store.watch(
      (state, getters) => getters.todayStationDataRefreshTime,
      (newValue, oldValue) => {
         this.l_lastdataupdate = newValue
      }
    )
  },
  // Data changed in mounted state.
  beforeUpdate() {
  },
  // Virtual DOM re-rendered and patched in mounted state.
  updated() {
  },
  // vm.$destroy() is called.
  beforeUnmount() {

  },
  // Teardown completed watchers, child components and event listeners
  unmounted() {
  },
  computed: {
    // Getter of ...
  },
  watch: {
  },
  methods:{
    // Common Function ============================


  }
}
</script>
